var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPropertyDeveloper(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103,
    height: 83,
    viewBox: "0 0 102.81 82.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1,.cls-2{fill:none;stroke-width:1.88px;stroke:#273133;stroke-miterlimit:10}.cls-2{stroke-width:1.77px}\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#273133",
    d: "M30.44 73.25l-24.02-.02V21.04L39.4 8.03l30.43 13.01v52.19l-21.34-.01",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#273133",
    d: "M29.5 73V45.85a5.13 5.13 0 015.1-5.15h9.74a5.13 5.13 0 015.1 5.15v27.23M70.65 23.38l4.78-.03-.06-6.19L39.4 1.02 1.02 16.75l-.07 6.33 4.95-.07",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#273133",
    d: "M57.84 67.6c-.72 2.51.53 6.15 4.61 8 6.1 2.73 2.84 6.1 16.58 6.38s12.6-4.12 17.31-5.71c4-1.36 5.68-3.87 5.32-8",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#273133",
    d: "M57.68 65.67c0-5.78 3.19-18.75 13.41-21 0 0 1.37-5.44 9.61-5.41 6.87 0 8 5.82 8 5.82s13.24 2.92 13.23 20.81c0 4.67-1 7.55-20.79 7.21-21.29-.37-23.45-1.93-23.46-7.43zM88.67 45.1C86 50 86 63.73 86 63.73M71.08 44.28c2.49 5 1.76 18.73 1.76 18.73M98 52.12c-1.19 2.41-3.27 11.67-2.76 17.52M61.79 51.27c1.07 2.45 2.72 11.81 1.93 17.62",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#273133",
    d: "M17.76 22.13h12.85v13.21H17.76z",
    className: "cls-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyDeveloper);
export default __webpack_public_path__ + "static/media/property_developer.4901d2a206b45a5eec8f8cd8c8a63c26.svg";
export { ForwardRef as ReactComponent };